import React from "react";
import { playAudioEffect } from "../../../store/audio-slice";
import { useAppDispatch } from "../../../store/hooks";
import { getFooterButtonAudio } from "../../../utils/AudioUtils";

interface Props {
  text: string;
  styleClass: string;
  onButtonClick: () => void;
}

const FooterButton: React.FC<Props> = ({ text, styleClass, onButtonClick }) => {
  const dispatch = useAppDispatch();

  return (
    <>
      <button
        type="button"
        className={`btn ${styleClass}`}
        onClick={() => {
          onButtonClick();
          dispatch(playAudioEffect(getFooterButtonAudio(styleClass)));
        }}
      >
        {text}
      </button>
    </>
  );
};

export default FooterButton;
